(function () {
  'use strict';

  /* ---------------------------------------------------------------
     Construction descriptions
  --------------------------------------------------------------- */
  var CONSTRUCTION_DESC = {
    'half canvas - hand stitched canvas with no fusing': 'Hand-stitched canvas, moulds to your body over time.',
    'fused - fully fused': 'Most structured. Holds shape through a long day.',
    'half lined - front panels fused': 'More breathable than fully fused, structured at the front panel.',
    'unlined - without fusing': 'Lightest feel. Best for Indian summers. Pure drape.'
  };

  function injectConstructionDescriptions() {
    var firstOption = document.querySelector('.variant-picker__option:nth-child(1) .variant-picker__option-values');
    if (!firstOption) return;
    firstOption.querySelectorAll('.block-swatch').forEach(function (sw) {
      if (sw.querySelector('.dva-construction-desc')) return;
      var label = (sw.textContent || '').trim().toLowerCase();
      var desc = CONSTRUCTION_DESC[label];
      if (!desc) return;
      var el = document.createElement('span');
      el.className = 'dva-construction-desc';
      el.textContent = desc;
      sw.appendChild(el);
    });
  }

  /* ---------------------------------------------------------------
     Trouser size fix — force horizontal row tiles
     Runs only when no construction descriptions were injected
     (i.e. this is a trouser/non-jacket product)
  --------------------------------------------------------------- */
  function fixTrouserSizes() {
    // If any construction description exists, this is a jacket — leave it alone
    if (document.querySelector('.dva-construction-desc')) return;
    // If the trouser size chart snippet is present, we're definitely on the trouser page
    // But we also just check: if the first option has NO construction keys, force row layout
    var allSwatches = document.querySelectorAll('.variant-picker__option .block-swatch');
    if (!allSwatches.length) return;

    var hasConstruction = false;
    allSwatches.forEach(function(sw) {
      var label = (sw.textContent || '').trim().toLowerCase();
      if (CONSTRUCTION_DESC[label]) hasConstruction = true;
    });
    if (hasConstruction) return;

    // Not a jacket — apply horizontal row layout to all option values
    document.querySelectorAll('.variant-picker__option .variant-picker__option-values').forEach(function(vals) {
      vals.style.setProperty('display', 'flex', 'important');
      vals.style.setProperty('flex-direction', 'row', 'important');
      vals.style.setProperty('flex-wrap', 'wrap', 'important');
      vals.style.setProperty('gap', '6px', 'important');
    });
    document.querySelectorAll('.variant-picker__option .block-swatch').forEach(function(sw) {
      sw.style.setProperty('width', 'auto', 'important');
      sw.style.setProperty('min-width', '44px', 'important');
      sw.style.setProperty('height', '44px', 'important');
      sw.style.setProperty('padding', '0 14px', 'important');
      sw.style.setProperty('flex-direction', 'row', 'important');
      sw.style.setProperty('align-items', 'center', 'important');
      sw.style.setProperty('justify-content', 'center', 'important');
      sw.style.setProperty('font-size', '12px', 'important');
      sw.style.setProperty('border-radius', '8px', 'important');
      sw.style.setProperty('white-space', 'nowrap', 'important');
    });
  }

  /* ---------------------------------------------------------------
     Move Size option to after the lapel guide in the DOM
  --------------------------------------------------------------- */
  function moveSizeAfterLapel() {
    var picker = document.querySelector('.variant-picker');
    var lapelGuide = document.getElementById('dva-lapel-guide');
    if (!picker || !lapelGuide) return;

    var sizeOption = picker.querySelector('.variant-picker__option:nth-child(3)');
    if (!sizeOption || sizeOption.dataset.dvaMoved) return;

    var sizeChart = document.querySelector('.dva-size-chart');
    var anchor = lapelGuide;
    if (sizeChart) {
      anchor.parentNode.insertBefore(sizeChart, anchor.nextSibling);
      anchor = sizeChart;
    }
    anchor.parentNode.insertBefore(sizeOption, anchor.nextSibling);
    sizeOption.dataset.dvaMoved = '1';
  }

  function init() {
    injectConstructionDescriptions();
    fixTrouserSizes();
    moveSizeAfterLapel();
  }

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  // Re-run if Prestige re-renders the picker
  var observer = new MutationObserver(function () {
    injectConstructionDescriptions();
    fixTrouserSizes();
    moveSizeAfterLapel();
  });
  var pickerRoot = document.querySelector('variant-picker, .variant-picker, main-product');
  if (pickerRoot) observer.observe(pickerRoot, { childList: true, subtree: true });

  /* ---------------------------------------------------------------
     Lapel selection
  --------------------------------------------------------------- */
  var selectedFitOption = null;

  document.addEventListener('click', function (e) {
    var target = e.target;
    var isCustomFit = false;
    if (target.tagName === 'INPUT' && target.type === 'radio') {
      if (target.value && target.value.toLowerCase().indexOf('custom') > -1) isCustomFit = true;
    }
    if (target.closest && target.closest('button')) {
      var btn = target.closest('button');
      if (btn.value && btn.value.toLowerCase().indexOf('custom') > -1) isCustomFit = true;
      if (btn.textContent && btn.textContent.toLowerCase().indexOf('custom fit') > -1) isCustomFit = true;
    }
    if (target.closest && target.closest('label')) {
      var lbl = target.closest('label');
      if (lbl.textContent && lbl.textContent.toLowerCase().indexOf('custom fit') > -1) isCustomFit = true;
    }
    if (!isCustomFit) return;
    openPopup();
  });

  function openPopup() {
    var overlay = document.getElementById('dva-measure-popup');
    if (!overlay) return;
    if (overlay.parentElement !== document.body) document.body.appendChild(overlay);
    selectedFitOption = null;
    ['dva-radio-call','dva-radio-self','dva-option-call','dva-option-self'].forEach(function(id) {
      var el = document.getElementById(id); if (el) el.classList.remove('is-selected');
    });
    var sf = document.getElementById('dva-self-measure'); if (sf) sf.style.display = 'none';
    var fe = document.getElementById('dva-popup-form'); if (fe) fe.style.display = 'block';
    var se = document.getElementById('dva-popup-success'); if (se) se.style.display = 'none';
    var er = document.getElementById('dva-popup-error'); if (er) er.style.display = 'none';
    overlay.style.display = 'block';
    overlay.scrollTop = 0;
    document.body.style.overflow = 'hidden';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.dva-popup__close')) { closePopup(); return; }
    var overlay = document.getElementById('dva-measure-popup');
    if (overlay && e.target === overlay) closePopup();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePopup(); });

  function closePopup() {
    var overlay = document.getElementById('dva-measure-popup');
    if (overlay) { overlay.style.display = 'none'; document.body.style.overflow = ''; }
  }

  window.dvaSelectFitOption = function (option) {
    selectedFitOption = option;
    document.getElementById('dva-radio-call').classList.toggle('is-selected', option === 'call');
    document.getElementById('dva-radio-self').classList.toggle('is-selected', option === 'self');
    document.getElementById('dva-option-call').classList.toggle('is-selected', option === 'call');
    document.getElementById('dva-option-self').classList.toggle('is-selected', option === 'self');
    var form = document.getElementById('dva-self-measure');
    if (form) form.style.display = option === 'self' ? 'block' : 'none';
    var err = document.getElementById('dva-popup-error');
    if (err) err.style.display = 'none';
  };

  function fileNamesOrEmpty(id) {
    var el = document.getElementById(id);
    if (!el || !el.files || el.files.length === 0) return '';
    var names = [];
    for (var i = 0; i < el.files.length; i++) names.push(el.files[i].name);
    return names.join(', ');
  }

  window.dvaSaveMeasurements = function () {
    var errorEl = document.getElementById('dva-popup-error');
    if (!selectedFitOption) {
      errorEl.textContent = 'Please select an option above before continuing.';
      errorEl.style.display = 'block'; return;
    }
    var form = document.querySelector('form[action*="/cart/add"]');
    if (selectedFitOption === 'call') {
      addProp(form, 'Custom Fit', 'Virtual measurement call requested \u2014 DVA will be in touch after your order is placed.');
      showSuccess('Request received', 'We\'ll reach out on WhatsApp after your order is placed to book your measurement call.');
    } else {
      var fields = ['dva-neck','dva-chest','dva-shoulder','dva-stomach','dva-armhole','dva-sleeve-length','dva-sleeve-opening','dva-across-front','dva-across-back','dva-hip-upper','dva-waist','dva-hip-lower','dva-thigh','dva-crotch','dva-front-rise','dva-back-rise','dva-inseam','dva-bottom-opening'];
      var missing = fields.filter(function(id) { var el = document.getElementById(id); return el && !el.value; });
      if (missing.length > 0) {
        errorEl.textContent = 'Please fill in all measurement fields before saving.';
        errorEl.style.display = 'block'; return;
      }
      errorEl.style.display = 'none';
      var map = {
        'dva-neck':'Neck','dva-chest':'Chest','dva-shoulder':'Shoulder','dva-stomach':'Stomach',
        'dva-armhole':'Armhole','dva-sleeve-length':'Sleeve Length','dva-sleeve-opening':'Sleeve Opening',
        'dva-across-front':'Across Front','dva-across-back':'Across Back','dva-hip-upper':'Hip (Upper)',
        'dva-waist':'Waist','dva-hip-lower':'Hip (Lower)','dva-thigh':'Thigh','dva-crotch':'Crotch',
        'dva-front-rise':'Front Rise','dva-back-rise':'Back Rise','dva-inseam':'Inseam','dva-bottom-opening':'Bottom Opening'
      };
      Object.keys(map).forEach(function(id) {
        var el = document.getElementById(id);
        if (el && el.value) addProp(form, map[id], el.value + ' in');
      });
      var photoNote = [];
      var front = fileNamesOrEmpty('dva-photo-front');
      var back = fileNamesOrEmpty('dva-photo-back');
      var side = fileNamesOrEmpty('dva-photo-side');
      if (front) photoNote.push('Front: ' + front);
      if (back) photoNote.push('Back: ' + back);
      if (side) photoNote.push('Side: ' + side);
      if (photoNote.length > 0) addProp(form, 'Reference Photos', photoNote.join(' | ') + ' (sent separately via WhatsApp/email)');
      var notes = document.getElementById('dva-special-requests');
      if (notes && notes.value) addProp(form, 'Special Requests', notes.value);
      addProp(form, 'Custom Fit', 'Measurements provided by customer');
      showSuccess('Measurements saved', 'Go ahead and add to cart \u2014 we have everything we need.');
    }
    setTimeout(closePopup, 2200);
  };

  function addProp(form, key, value) {
    if (!form) return;
    var inp = document.createElement('input');
    inp.type = 'hidden'; inp.name = 'properties[' + key + ']'; inp.value = value;
    form.appendChild(inp);
  }

  function showSuccess(title, msg) {
    document.getElementById('dva-popup-form').style.display = 'none';
    document.getElementById('dva-success-title').textContent = title;
    document.getElementById('dva-success-msg').textContent = msg;
    document.getElementById('dva-popup-success').style.display = 'block';
  }

  /* Lapel required validation */
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
    var lapelInput = form.querySelector('input[name="properties[Lapel]"]');
    if (!lapelInput || !lapelInput.value) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var err = document.getElementById('dva-lapel-error');
      if (err) err.style.display = 'inline';
      var guide = document.getElementById('dva-lapel-guide');
      if (guide) guide.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, true);

})();
